export const setupScript = (url: string, callback?: () => void) => {
    const script = document.createElement('script');
    if (callback) {
        script.addEventListener('load', callback);
    }
    script.src = url;
    script.async = true;
    script.type = 'text/javascript';
    document.head.appendChild(script);
};
